// The app-wide render safety net (STABILITY_FIX_PLAN A1, 2026-09-02). Until
// this existed, ANY exception thrown during render or a hook white-screened
// the entire app — ui/src had zero boundaries. One instance wraps the whole
// tree (App.js, catch of last resort) and one wraps each routed page inside
// its Route element (Main.jsx) so a page crash leaves the shell, sidebars and
// the other pages alive.
//
// Placement rules (pre-flight audit): inside a Route's `element`, never
// around the AnimatePresence/motion.div pair (it tracks its direct child by
// key — a wrapper there breaks exit animations); OUTSIDE the graph route's
// Suspense (Suspense only handles loading, so the boundary also catches
// lazy-chunk load rejections). Key page boundaries by ROUTE so navigating
// away and back resets a stuck error state.
import React from "react";

import { ClearChrome } from "../../chrome/useChrome";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Console is the only sink today; the label says WHICH boundary fired.
    console.error(
      `[ErrorBoundary:${this.props.label || "app"}]`,
      error,
      info?.componentStack,
    );
  }

  render() {
    if (this.state.error) {
      return (
        <>
        {/* Route boundaries (Main.jsx) opt in: the crash just unmounted the
            route's chrome publisher, and the frames HOLD last content until
            the next publish — so the fallback itself publishes "nothing"
            (Phase X B review fix). Only valid inside SlotsProvider; the
            app-level boundary (App.js) must NOT set this. */}
        {this.props.clearChrome ? <ClearChrome /> : null}
        <div className="flex h-full w-full flex-1 flex-col items-center justify-center gap-y-3 bg-mainBg p-8 font-poppins text-mainText">
          <p className="text-sm font-light text-mutedText">
            {this.props.label
              ? `The ${this.props.label} panel hit an error.`
              : "Something went wrong."}
          </p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="rounded-xl border border-mainDivider bg-mainBg/95 px-4 py-1.5 text-sm text-mainText transition-colors hover:bg-mainButtonBg/50"
          >
            Retry
          </button>
        </div>
        </>
      );
    }
    return this.props.children;
  }
}
